export default {
  yandexApiSettings: {
    apiKey: '25ec803b-388c-463b-b9cb-111c831bb215',
    lang: 'ru_RU',
    version: '2.1'
  }
}



// WEBPACK FOOTER //
// ./src/config.js